import { ColorModeScript } from '@chakra-ui/react';
import React, { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import CQClientPortalApp from './CQClientPortalApp';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import "react-perfect-scrollbar/dist/css/styles.css"


const container = document.getElementById('cq-client-portal');
const root = ReactDOM.createRoot(container);

root.render(
  <>
    <ColorModeScript />
    <CQClientPortalApp />
  </>
);

serviceWorker.unregister();
reportWebVitals();
